import {
    Breadcrumbs,
    BreadcrumbsLink,
    Link,
    Typography,
    Visibility,
} from "@octopus-energy/coral/atoms"
import { IconChevronLeft } from "@octopus-energy/icons"
import { useIsClient } from "@octopus-energy/utils"
import { useDashboardLayoutBreadcrumbContext } from "../contexts/DashboardLayoutBreadcrumbContext"

export default function DashboardLayoutBreadcrumbs() {
    const { breadcrumbs, previousPage } = useDashboardLayoutBreadcrumbContext()

    const isClient = useIsClient()

    return (
        <>
            {!!previousPage && isClient && (
                <Visibility hidden={{ base: false, md: true }}>
                    <Typography
                        textStyle="h5"
                        component="span"
                        color="base300"
                    >
                        <Link
                            href={previousPage.href}
                            color="inherit"
                        >
                            <IconChevronLeft
                                size={12}
                                color="inherit"
                            />{" "}
                            Retour
                        </Link>
                    </Typography>
                </Visibility>
            )}
            <Visibility hidden={{ base: true, md: false }}>
                <Breadcrumbs>
                    {breadcrumbs.map((breadcrumb, index) => {
                        return (
                            <BreadcrumbsLink
                                href={breadcrumb?.href}
                                key={index}
                                current={index === breadcrumbs.length - 1}
                            >
                                {breadcrumb?.text}
                            </BreadcrumbsLink>
                        )
                    })}
                </Breadcrumbs>
            </Visibility>
        </>
    )
}
